import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { PartGroup } from '../../../interface/part-group';
import { PartSubgroup } from '../../../interface/part-subgroup';
import { GroupService } from '../../../service/group.service';
import { LayoutService } from '../../../service/layout.service';
import { SnackbarService } from '../../../service/snackbar.service';
import { SubgroupService } from '../../../service/subgroup.service';
import { CommonModule } from '@angular/common';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatButton } from '@angular/material/button';
import { SingleClickDirective } from 'src/app/shared/directives/single-click.directive';
import { MatInput } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-subgroup-by-expense-type-edit',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,

    SingleClickDirective,
    TranslateModule,

    MatDialogTitle,
    MatDialogContent,
    MatLabel,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
    MatFormField,
    MatInput,

  ],
  templateUrl: './subgroup-by-expense-type-edit.component.html',
  styleUrl: './subgroup-by-expense-type-edit.component.scss'
})
export class SubgroupByExpenseTypeEditComponent {

  form: FormGroup;
  subgroup: PartSubgroup

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      subgroup?: PartSubgroup,
      group?: PartGroup,
      partGroups?: PartGroup[]
    },
    private dialogRef: MatDialogRef<SubgroupByExpenseTypeEditComponent>,
    private formBuilder: FormBuilder,
    public groupService: GroupService,
    private subgroupService: SubgroupService,
    private layout: LayoutService,
    private snackbar: SnackbarService
  ) {
    if (data) {
      this.subgroup = data.subgroup
    }
  }

  displayGroup = (group?: PartGroup) => {
    return group && group.description ? group.description : "";
  }

  ngOnInit() {
    this.buildForm()
  }

  buildForm() {
    if (this.subgroup) {
      this.form = this.formBuilder.group({
        _id: this.subgroup._id,
        description: [this.subgroup.description, Validators.required],
        group: [this.data.group || '', Validators.required]
      })
    } else {
      this.form = this.formBuilder.group({
        _id: '',
        description: ["", Validators.required],
        group: [this.data.group || '', Validators.required]
      })
    }
  }

  async onSubmit() {
    let subgroup: PartSubgroup = this.form.getRawValue();
    const isUpdate = Boolean(subgroup._id);
    try {
      this.layout.loader = true;
      if (isUpdate) {
        await this.subgroupService.update(subgroup)
      } else {
        const id = await this.subgroupService.register(subgroup);
        subgroup._id = id;
      }
      this.snackbar.success(isUpdate ? 'SUBGROUP.UPDATED' : 'SUBGROUP.ADDED');
    } catch (error) {
      console.error("Falha ao registrar subgrupo\n\n", error)
      this.snackbar.error(isUpdate ? 'SUBGROUP.NOT_UPDATED' : 'SUBGROUP.NOT_ADDED', null, error)
    } finally {
      this.layout.loader = false;
    }

    this.dialogRef.close(subgroup);
  }

  close() {
    this.dialogRef.close(null);
  }
}
